import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {
  CreatePlantRequestModel,
  CreatePlantResponseModel,
  DeletePlantResponseModel,
  PlantCriteriaRequestModel,
  PlantCriteriaResponseModel,
  UpdatePlantRequestModel,
  UpdatePlantResponseModel,
} from '@roi/common/models/plant.model';
import { Observable } from 'rxjs';
import { Endpoint } from '../constants/endpoint';
import { TransformTool } from '../tools/transform.tool';

@Injectable({ providedIn: 'root' })
export class PlantFetch {
  private http = inject(HttpClient);

  public getByCriteria(
    request: PlantCriteriaRequestModel
  ): Observable<PlantCriteriaResponseModel> {
    return this.http.get<PlantCriteriaResponseModel>(
      `${Endpoint.Plant}${TransformTool.ConvertObjectToQueryString(request)}`
    );
  }
  public create(
    request: CreatePlantRequestModel
  ): Observable<CreatePlantResponseModel> {
    return this.http.post<CreatePlantResponseModel>(
      `${Endpoint.Plant}`,
      request
    );
  }
  public update(
    request: UpdatePlantRequestModel
  ): Observable<UpdatePlantResponseModel> {
    return this.http.put<UpdatePlantResponseModel>(
      `${Endpoint.Plant}`,
      request
    );
  }
  public delete(id: string): Observable<DeletePlantResponseModel> {
    return this.http.delete<DeletePlantResponseModel>(
      `${Endpoint.Plant}/${id}`
    );
  }
}
